import {onLoad} from "../base/onLoad";

onLoad(() => {
    const images = Array.from(document.querySelectorAll('img'));
    for (const image of images) {
        if (image.offsetHeight > image.offsetWidth) {
            image.style.objectPosition = 'top';
        }
    }
}, {
    checkForElements: ['img']
});